import React from 'react'

import { Table } from 'semantic-ui-react'

const DataTableLite = ({ columns, data, formatter, className }) => (
  <Table singleLine className={['DataTableLite', className].filter(f=>!!f).join(' ')}>
    <Table.Header>
      <Table.Row>
        {columns &&
          columns.map((col, i) => (
            <Table.HeaderCell key={i}>{col.name}</Table.HeaderCell>
          ))}
      </Table.Row>
    </Table.Header>

    <Table.Body>
      {data &&
        data.length > 0 &&
        data.map((row, i) => (
          <Table.Row key={i}>
            {columns &&
              columns.map((col, ii) => (
                <Table.Cell key={ii}>
                  {formatter && typeof formatter === 'function'
                    ? formatter(row[col.dataKey])
                    : row[col.dataKey]}
                </Table.Cell>
              ))}
          </Table.Row>
        ))}
    </Table.Body>
  </Table>
)

export default DataTableLite
